/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import { Comment, Message } from 'semantic-ui-react';

const CpgCommentDisplay = ({ complaintCpgData }) => {
  return (
    <>
      {' '}
      {complaintCpgData &&
        complaintCpgData.cpgByComplaintId.items &&
        complaintCpgData.cpgByComplaintId.items.map((data) => (
          <div key={data.id}>
            <Comment.Group>
              <Comment>
                {/* <Comment.Avatar src="https://react.semantic-ui.com/images/avatar/small/joe.jpg" /> */}
                <Comment.Content>
                  <Comment.Author as="a">{data.profileName}</Comment.Author>
                  <Comment.Metadata>
                    <div>{data.createdAt}</div>
                  </Comment.Metadata>
                  <Comment.Text>
                    <Message info>{data.content}</Message>
                  </Comment.Text>
                </Comment.Content>
              </Comment>
            </Comment.Group>
          </div>
        ))}
    </>
  );
};

export default CpgCommentDisplay;
